import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/moment1.webp")